import i18n from "i18next";
import React from "react";
import PropTypes from "prop-types";

import Button from "../../Common/Button";

export const NoFilters = props => (
  <div className="sorted-list__nothing --filter">
    <span className="sorted-list__nothing-title">{i18n.t("table.nothing")}</span>
    <span className="sorted-list__nothing-result">{i18n.t("table.noFilters")}</span>
    <Button className="sorted-list__button" onClick={props.onClick} label={i18n.t("customer.getStarted")} />
  </div>
);

NoFilters.propTypes = {
  onClick: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/Customer/Filters/NoFilters.js